import React from "react";
import HoverMenu from "material-ui-popup-state/HoverMenu";
import { Box, Divider, MenuItem } from "@mui/material";
import styles from "./navDropdown.module.scss";
import stylesParent from "../navMenuItem/./navMenuItem.module.scss";

import i18n from "i18next";

import {
  usePopupState,
  bindHover,
  bindMenu,
} from "material-ui-popup-state/hooks";
import { useNavigate } from "react-router-dom";
import { useNavbarContext } from "../../NavbarCotext";
import PropTypes from "prop-types";

const NavDropdown = (props) => {
  const { icon_style, link_name, menu_list, setIsActivefn } = props;
  const { navState, setNavState } = useNavbarContext();
  const setSelectedMenuName = (val) => {
    setNavState({ selectedNavItem: val });
  };
  const history = useNavigate();
  const popupState = usePopupState({
    variant: "popover",
    popupId: "demoMenu",
  });
  // This section is  needed dont remove - senario - select one and hover on dropdown
  if (popupState.isOpen) {
    if (navState.selectedNavItem !== link_name) {
      setIsActivefn(true);
    }
  } else {
    setIsActivefn(false);
  }
  // This section is needed dont remove

  const handleClose = () => {
    popupState.close();
  };

  const handleMenuClick = (link) => {
    history(link);
    setSelectedMenuName(link_name);

    handleClose();
  };
  
  return (
    <Box
      {...bindHover(popupState)}
      className={styles.dropdownWrapper}
      data-testid="nav-dropdown"
    >
      <Box sx={{ display: "flex" }}>
        <Box className={stylesParent.navMenuItemWrapper}>
          <Box className={`${icon_style} ${stylesParent["iconWrapper"]}`}></Box>
          <Box className={stylesParent.textWrapper}>
            <Box>{i18n.t(link_name)}</Box>
            <span
              className={
                popupState.isOpen
                  ? styles.chevronUpIcon
                  : styles.chevronDownIcon
              }
            ></span>
          </Box>
        </Box>
      </Box>
      <HoverMenu
        className={styles.dropDownMenu}
        {...bindMenu(popupState)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {menu_list?.map((menu, index) => (
          <Box key={index}>
            <MenuItem onClick={() => handleMenuClick(menu.link)} disableRipple>
              {i18n.t(menu.title)}
            </MenuItem>
            {index !== menu_list.length - 1 ? <Divider sx={{ my: 0.5 }} /> : ""}
          </Box>
        ))}
      </HoverMenu>
    </Box>
  );
};

export default NavDropdown;
NavDropdown.propTypes ={
  icon_style : PropTypes.any, 
  link_name : PropTypes.any, 
  menu_list : PropTypes.any, 
  setIsActivefn  : PropTypes.any, 
}